import Middleware from './middleware'
import { Auth, authMiddleware, ExpiredAuthSessionError } from '~auth/runtime'

// Active schemes
import { default as Scheme$8e76 } from '/builds/write/write-app/auth-schemes/keycloak.js'

Middleware.auth = authMiddleware

export default function (ctx, inject) {
  // Options
  const options = {
  "resetOnError": false,
  "ignoreExceptions": false,
  "scopeKey": "scope",
  "rewriteRedirects": true,
  "fullPathRedirect": false,
  "watchLoggedIn": true,
  "redirect": {
    "login": "/",
    "logout": "/?logout",
    "home": "/feature/write-chapter",
    "callback": "/login"
  },
  "vuex": {
    "namespace": "auth"
  },
  "cookie": {
    "prefix": "auth.",
    "options": {
      "path": "/",
      "expires": 30
    }
  },
  "localStorage": {
    "prefix": "auth."
  },
  "defaultStrategy": "keycloak"
}

  // Create a new Auth instance
  const $auth = new Auth(ctx, options)

  // Register strategies
  // keycloak
  $auth.registerStrategy('keycloak', new Scheme$8e76($auth, {
  "endpoints": {
    "authorization": "https://auth.hesse.ai/realms/hesse/protocol/openid-connect/auth",
    "token": "https://auth.hesse.ai/realms/hesse/protocol/openid-connect/token",
    "userInfo": "https://api-write.hesse.ai/api/auth/user/customer",
    "logout": "https://auth.hesse.ai/realms/hesse/protocol/openid-connect/logout"
  },
  "user": {
    "property": "data"
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "token": {
    "property": "access_token",
    "type": "Bearer",
    "maxAge": 36000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "accessType": "offline",
  "clientId": "hesse-web",
  "scope": [
    "openid",
    "profile",
    "email"
  ],
  "codeChallengeMethod": "S256",
  "name": "keycloak"
}))

  // Inject it to nuxt context as $auth
  inject('auth', $auth)
  ctx.$auth = $auth

  // Initialize auth
  return $auth.init().catch(error => {
    if (process.client) {
      // Don't console log expired auth session errors. This error is common, and expected to happen.
      // The error happens whenever the user does an ssr request (reload/initial navigation) with an expired refresh
      // token. We don't want to log this as an error.
      if (error instanceof ExpiredAuthSessionError) {
        return
      }

      console.error('[ERROR] [AUTH]', error)
    }
  })
}
